import { render, staticRenderFns } from "./StudentEditTabSocialLinks.vue?vue&type=template&id=73a8550c&scoped=true&"
import script from "./StudentEditTabSocialLinks.vue?vue&type=script&lang=js&"
export * from "./StudentEditTabSocialLinks.vue?vue&type=script&lang=js&"
import style0 from "./StudentEditTabSocialLinks.vue?vue&type=style&index=0&id=73a8550c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a8550c",
  null
  
)

export default component.exports